import { dataLayer } from 'analytics/data-layer';

export const trackProductPromotionClick = (promotionDescription: string) =>
  dataLayer.push({ event: 'product_promo_clicked', promotion: { name: promotionDescription } });
